import config from '../startup/config';

/**
 * Manages getting items from and saving items to local storage
 */
export default class Storage {
    /**
     * Gets an item from local storage
     * returns null if the key doesn't exist
     *
     * @param {string} key
     * @returns {string} data in string format
     */
    getItem(key: string): string | null {
        let path = `${config.prefix}${key}`;
        return localStorage.getItem(path);
    }

    /**
     * Sets an item and assings a given key to it
     *
     * @param {string} key
     * @param {string | integer | boolean} value
     */
    setItem(key: string, value: string | number | boolean): void {
        let path = `${config.prefix}${key}`;
        localStorage.setItem(path, String(value));
    }

    /**
     * Sets the value to an existing item, or creates a new record
     * if the key doesn't exist
     *
     * @param {string} key
     * @param {string | integer | boolean} defaultValue
     * @returns {string} value
     */
    initItem(key: string, defaultValue: string | number | boolean): string {
        const path = `${config.prefix}${key}`;
        let item = localStorage.getItem(path);

        if (item === null) {
            localStorage.setItem(path, String(defaultValue));
            return String(defaultValue);
        }

        return item;
    }
}
